// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { HP_FINANCE_AND_ANALYTICS_REDUCER_KEY } from "..";
import { getPeriodValue } from "./helpers";
import {
  hp_fa_FinanceTeamMonth,
  hp_fa_costPerHead,
  hp_fa_hrTeamMonth,
  hp_fa_legalTeamMonth,
  hp_fp_foundersAndPartnersHeaderMonth,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "hp_fa_";

export const FINANCE_AND_ANALYTICS_HEADER_KEY = prefix + "financeAndAnalytics";
export const HEAD_COUNT_KEY = prefix + "headCount";
export const FINANCE_TEAM_KEY = prefix + "financeTeam";
export const DATA_SCIENCE_ANALYTICS_TEAM_KEY =
  prefix + "dataScienceAnalyticsTeam";
export const HR_TEAM_KEY = prefix + "hrTeam";
export const LEGAL_TEAM_KEY = prefix + "legalTeam";
export const COST_PER_HEAD_KEY = prefix + "costPerHead";

export const hpFinanceAndAnalyticsItems = [
  FINANCE_AND_ANALYTICS_HEADER_KEY,
  HEAD_COUNT_KEY,
  FINANCE_TEAM_KEY,
  DATA_SCIENCE_ANALYTICS_TEAM_KEY,
  HR_TEAM_KEY,
  LEGAL_TEAM_KEY,
  COST_PER_HEAD_KEY,
];

export const initialState = {
  [FINANCE_AND_ANALYTICS_HEADER_KEY]: {
    title: "Finance & Analytics & Operations",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const headCount = Number(
        getReducerFunc(HP_FINANCE_AND_ANALYTICS_REDUCER_KEY)[
          HEAD_COUNT_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );

      const costPerHead = getPeriodValue(
        getReducerFunc(HP_FINANCE_AND_ANALYTICS_REDUCER_KEY)[COST_PER_HEAD_KEY],
        yearKey,
        getReducerFunc
      );

      return headCount * costPerHead;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [HEAD_COUNT_KEY]: {
    title: "Head Count",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 2; i < hpFinanceAndAnalyticsItems.length - 1; i++) {
        result += getPeriodValue(
          getReducerFunc(HP_FINANCE_AND_ANALYTICS_REDUCER_KEY)[
            hpFinanceAndAnalyticsItems[i]
          ],
          yearKey,
          getReducerFunc
        );
      }
      return result;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [FINANCE_TEAM_KEY]: {
    title: "Finance Team",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fa_FinanceTeamMonth,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [DATA_SCIENCE_ANALYTICS_TEAM_KEY]: {
    title: "Data Science & Analytics",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fa_FinanceTeamMonth,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [HR_TEAM_KEY]: {
    title: "HR and People & Culture",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fa_hrTeamMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [LEGAL_TEAM_KEY]: {
    title: "Legal Team",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fa_legalTeamMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [COST_PER_HEAD_KEY]: {
    title: "Cost per Head",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fa_costPerHead,
    years: {
      [years.YEAR_1_KEY]: 2500,
      [years.YEAR_2_KEY]: 2500,
      [years.YEAR_3_KEY]: 2500,
      [years.YEAR_4_KEY]: 2500,
      [years.YEAR_5_KEY]: 2500,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const hpFinanceAndAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FINANCE_ANALYTICS_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_FINANCE_ANALYTICS_BY_MONTHS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_FINANCE_ANALYTICS_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_FINANCE_ANALYTICS_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default hpFinanceAndAnalyticsReducer;
